import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ImageDirective } from '../../../@common/DOM/image.directive';
import { MetaService } from '../../../@domain/seo/meta.service';

@Component({
    selector: 'app-not-found',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ImageDirective,
        RouterLink
    ],
    styles: `
        :host {
            padding-top: 2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            text-align: center;
            font-size: 1.5rem;

            @media (max-width: 679px) {
                padding-top: 0;
                font-size: 1.2rem;

                img {
                    width: 100%;
                }

                .content {
                    padding: 0 1rem;
                }
            }

            h1 {
                font-size: 3rem;
            }

            .button-container {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 2rem;
                margin-top: 3rem;

                .btn {
                    font-size: 1.25rem;
                }
            }
        }
    `,
    template: `
        <img src="/assets/backgrounds/not-found.png" alt="forbidden image" loading="eager">
        <br/>
        <div class="content">
            <h1>Oops...</h1>
            <br>
            <p>There is nothing here..</p>
            <br>
            <p>We could not find the page you are looking for.</p>
        </div>
        <div class="button-container">
            <a class="btn btn-primary" routerLink="/">
                Go back
            </a>
        </div>
    `
})
export default class NotFoundPage {
    private metaService = inject(MetaService);

    constructor() {
        afterNextRender(() => {
            const navigationId = history.state.navigationId;

            if (navigationId) {
                history.replaceState({ navigationId: navigationId - 1 }, '');
            }
        })

        this.metaService.set({
            title: 'Page Not Found - Videolectures',
            description: 'The page you are looking for is not found.',
            image: undefined,
            index: true
        })
    }

}
